import React from 'react';
import { RadioOptionGroupStyled } from '../../asset/styled/component/RadioOptionGroupStyled';
import CheckBox from './CheckBox';
import Radio from './Radio';

const RadioOptionGroup = ({
  label,
  options,
  checked,
  isDisabled,
  onChange,
  optionChecked,
  onOptionChange,
  style,
  isOpen,
  htm109Duplicated,
}) => {
  // 클릭 이벤트를 한 번만 처리하기 위한 핸들러
  const handleClick = () => {
    if (!isDisabled) {
      onChange();
    }
  };

  // 옵션 변경 시 이벤트 중지를 위한 핸들러
  const handleOptionChange = e => {
    e.stopPropagation(); // 부모로 이벤트 전파 방지
    if (!isDisabled) {
      onOptionChange(e);
    }
  };

  // 옵션 컨테이너 클릭 시 이벤트 전파 방지
  const handleOptionsClick = e => {
    e.stopPropagation();
  };

  return (
    <RadioOptionGroupStyled
      onClick={onChange}
      checked={checked}
      isDisabled={isDisabled}
      style={style}>
      <CheckBox
        variant="circle"
        label={label}
        size="regular"
        isDisabled={isDisabled}
        checked={checked}
        onChange={onChange}
      />
      <div
        className={`radioOptionGroup ${
          (isOpen !== undefined ? isOpen : checked) && options?.length > 0 ? 'open' : 'close'
        }`}
        onClick={handleOptionsClick}>
        {options?.map((option, index) => (
          <Radio
            key={index}
            label={option.label}
            name={option.name}
            value={option.value}
            checked={optionChecked === option.value}
            disabled={isDisabled || htm109Duplicated(option)}
            size="small"
            onChange={handleOptionChange}
            style={{ alignItems: 'flex-start' }}
          />
        ))}
      </div>
    </RadioOptionGroupStyled>
  );
};

export default RadioOptionGroup;
